import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg" />
              </div>
              <span className="font-heading text-2xl text-background-50">
                亲嘴视频
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80 max-w-sm">
              专注亲吻主题视频的内容聚合平台，收录影视片段精选、短视频合集与情感专题，帮你快速发现并观看喜欢的亲吻视频作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-3 text-sm">
              {categories.map((c) => (
                <li key={c.key}>
                  <Link
                    to={`/category/${c.key}`}
                    className="text-background-200/80 hover:text-primary-200 transition-colors cursor-pointer"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50 mb-4">
              快捷入口
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link
                  to="/search"
                  className="text-background-200/80 hover:text-primary-200 transition-colors cursor-pointer"
                >
                  搜索视频
                </Link>
              </li>
              <li>
                <Link
                  to="/special/s1"
                  className="text-background-200/80 hover:text-primary-200 transition-colors cursor-pointer"
                >
                  银幕经典之吻
                </Link>
              </li>
              <li>
                <Link
                  to="/special/s2"
                  className="text-background-200/80 hover:text-primary-200 transition-colors cursor-pointer"
                >
                  雨中的告白
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-200/80 hover:text-primary-200 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-200/60">
          <p>© {new Date().getFullYear()} 亲嘴视频 · 本站内容均为演示用途，仅供学习交流。</p>
          <p>联系方式：contact@qinzui-video.example</p>
        </div>
      </div>
    </footer>
  );
}